// extracted by mini-css-extract-plugin
module.exports = {"container":"ShipmentQR_container__2hbqG","content":"ShipmentQR_content__1j8XL"};